var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37019 4.5L6.19712 9M3.80288 9L3.62981 4.5M8.61382 2.89528C8.78481 2.92111 8.95521 2.94873 9.125 2.97815M8.61382 2.89528L8.0799 9.83628C8.03482 10.4224 7.54607 10.875 6.95821 10.875H3.04179C2.45393 10.875 1.96519 10.4224 1.9201 9.83628L1.38618 2.89528M8.61382 2.89528C8.04061 2.80872 7.46075 2.74243 6.875 2.69716M0.875 2.97815C1.04479 2.94873 1.21519 2.92111 1.38618 2.89528M1.38618 2.89528C1.95939 2.80872 2.53925 2.74243 3.125 2.69716M6.875 2.69716V2.23909C6.875 1.64941 6.41967 1.15712 5.83029 1.13826C5.55461 1.12944 5.27782 1.125 5 1.125C4.72218 1.125 4.44539 1.12944 4.16971 1.13826C3.58033 1.15712 3.125 1.64941 3.125 2.23909V2.69716M6.875 2.69716C6.25628 2.64935 5.63098 2.625 5 2.625C4.36902 2.625 3.74372 2.64935 3.125 2.69716",
    stroke: "#EF4444",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2a2e8a1ce6b4cdcc8015dec66a5dfc06.svg";
export { ForwardRef as ReactComponent };